import Bestellung from "@/entities/common/bestellung"
import { Bezahlart, Terminart } from "@/entities/common/enums"
import BPAbholungKundeRequest from "@/entities/common/pending/bp_abholung_kunde_request"
import RemoteResult from "@/entities/common/remote_result"
import BestellungInsertRequest from "@/entities/common/request/bestellung_insert_request"
import router from "@/router"
import store from "@/store"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import Validator from "@/util/validator"
import BaseLogic from "../base_logic"
import MainLogic from "../main_logic"

export default class KundendatenLogic extends BaseLogic {
  insertWorking: boolean = false
  insertError: boolean = false

  formValid: boolean = true
  kundeNachname?: string = null
  kundeVorname?: string = null
  _kundeEmail?: string = null
  kundeTelefon?: string = null

  get kundeEmail(): string {
    return this._kundeEmail
  }

  set kundeEmail(newValue: string) {
    if (newValue == null) this._kundeEmail = null
    else this._kundeEmail = newValue.toLowerCase()
  }

  nachnameRules: any[] = [(v) => !!v || "Bitte Nachname angeben"]

  vornameRules: any[] = [(v) => !!v || "Bitte Vorname angeben"]

  emailRules: any[] = Validator.emailValidate

  telefonRules: any[] = [(v) => !!v || "Bitte Telefon angeben"]

  init() {
    this.mainLogic.bestellungPendingListeners.push(() => {
      var ad = this.mainLogic.bestellungPending.abholung
      if (ad.kundeNachname) {
        this.kundeNachname = ad.kundeNachname
      }
      if (ad.kundeVorname) {
        this.kundeVorname = ad.kundeVorname
      }
      if (ad.kundeEmail) {
        this.kundeEmail = ad.kundeEmail
      }
      if (ad.kundeTelefon) {
        this.kundeTelefon = ad.kundeTelefon
      }
    })

    var ad = this.mainLogic.bestellungPending.abholung
    if (ad.kundeNachname) {
      this.kundeNachname = ad.kundeNachname
    }
    if (ad.kundeVorname) {
      this.kundeVorname = ad.kundeVorname
    }
    if (ad.kundeEmail) {
      this.kundeEmail = ad.kundeEmail
    }
    if (ad.kundeTelefon) {
      this.kundeTelefon = ad.kundeTelefon
    }
  }

  weiter() {
    var terminart = this.mainLogic.bestellungPending.terminart
    
    if (terminart == Terminart.RESERVIERUNG) {
      this.mainLogic.bestellungPending.reservierung.kundeNachname =
        this.kundeNachname
      this.mainLogic.bestellungPending.reservierung.kundeVorname =
        this.kundeVorname
      this.mainLogic.bestellungPending.reservierung.kundeTelefon =
        this.kundeTelefon
      this.mainLogic.bestellungPending.reservierung.kundeEmail = this.kundeEmail

      var request = new BestellungInsertRequest()
      var nbd = this.mainLogic.bestellungPending
      var nbdR = nbd.reservierung

      request.terminart = terminart
      request.identifier = store.state.user.identifier
      request.filialeId = nbd.filiale.filialeId
      request.bezahlart = Bezahlart.BARZAHLUNG

      request.createReservierung()
      request.reservierung.kundeNachname = nbdR.kundeNachname
      request.reservierung.kundeVorname = nbdR.kundeVorname
      request.reservierung.kundeTelefon = nbdR.kundeTelefon
      request.reservierung.kundeEmail = nbdR.kundeEmail
      request.reservierung.zeitVon = nbdR.zeitVon
      request.reservierung.zeitBis = nbdR.zeitBis
      request.reservierung.personen = nbdR.anzahlPersonen
      request.reservierung.art = "ONLINE"
      request.reservierung.bestellart = "SELBST"

      Poster.postUser<RemoteResult<Bestellung>>(
        RestPaths.bestellungKundeEinfuegen,
        request
      ).then((response) => {
        if (response.data.success) {
          router.push({
            name: RouteNames.NEU.RESERVIERUNG_SELECT_VORBESTELLUNG,
          })
        }
      })
    } else if (terminart == Terminart.ABHOLUNG) {
      this.insertError = false
      this.insertError = true

      var krequest = new BPAbholungKundeRequest()
      krequest.id = store.state.user.identifier
      krequest.kundeNachname = this.kundeNachname
      krequest.kundeVorname = this.kundeVorname
      krequest.kundeTelefon = this.kundeTelefon
      krequest.kundeEmail = this.kundeEmail

      Poster.postUser<RemoteResult<any>>(
        RestPaths.bestellungpendingAbholungKunde,
        krequest
      )
        .then((response) => {
          if (response.data.success) {
            this.mainLogic.bestellungPending.abholung.kundeNachname =
              this.kundeNachname
            this.mainLogic.bestellungPending.abholung.kundeVorname =
              this.kundeVorname
            this.mainLogic.bestellungPending.abholung.kundeTelefon =
              this.kundeTelefon
            this.mainLogic.bestellungPending.abholung.kundeEmail =
              this.kundeEmail

            router.push({ name: RouteNames.NEU.BESTAETIGEN_ABHOLUNG })
          } else {
            this.insertError = true
          }
          this.insertWorking = false
        })
        .catch(() => {
          this.insertError = true
          this.insertWorking = false
        })
    }
  }
}
